import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-display text-xl md:text-2xl font-bold text-slate-950 mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-3 text-sm md:text-base">{children}</div>
  </div>
);

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Navbar />
      <header className="pt-36 pb-12 px-4 bg-slate-50 border-b border-slate-100">
        <div className="max-w-3xl mx-auto">
          <span className="eyebrow">Legal</span>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-slate-950 mt-3">Terms of Service</h1>
          <p className="text-slate-500 mt-4">Last updated: June 2026</p>
        </div>
      </header>

      <main className="px-4 py-14">
        <div className="max-w-3xl mx-auto">
          <p className="text-slate-600 leading-relaxed mb-10 text-sm md:text-base">
            These Terms of Service ("Terms") govern your use of the Fair Rideshare LLC website and your rental of
            any vehicle from Fair Rideshare LLC ("Fair Rideshare," "we," "us," or "our"). By booking a vehicle or
            using our website, you agree to these Terms.
          </p>

          <Section title="1. Eligibility">
            <p>To rent a vehicle, you must:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Be at least 21 years of age.</li>
              <li>Hold a valid, unexpired driver's license.</li>
              <li>Provide accurate information and meet our screening requirements.</li>
            </ul>
          </Section>

          <Section title="2. Rates, Deposit & Payments">
            <ul className="list-disc pl-6 space-y-1">
              <li>The weekly rental rate is <strong>$275 per week</strong>.</li>
              <li>A <strong>$200 refundable security deposit</strong> is required before pickup.</li>
              <li>Payments are made via Cash App to <strong>$easymoneyAL</strong>.</li>
              <li>The deposit is returned at the end of the rental, subject to vehicle condition and any outstanding balances.</li>
            </ul>
          </Section>

          <Section title="3. Booking & Confirmation">
            <p>
              Submitting a booking request does not guarantee a reservation. Reservations are confirmed once we
              verify your eligibility and receive your deposit. We aim to confirm within 24 hours.
            </p>
          </Section>

          <Section title="4. Use of Vehicle">
            <ul className="list-disc pl-6 space-y-1">
              <li>Vehicles may be used for personal driving and rideshare/delivery work (e.g., Uber, Lyft, DoorDash).</li>
              <li>You must operate the vehicle lawfully and only allow authorized drivers to drive it.</li>
              <li>No illegal activity, subletting, or use outside the agreed area without prior written approval.</li>
              <li>You are responsible for parking tickets, tolls, and traffic violations during your rental.</li>
            </ul>
          </Section>

          <Section title="5. Insurance & Liability">
            <p>
              Rentals are insurance-ready as described at the time of booking. You are responsible for any damage,
              loss, or theft of the vehicle that is not covered by applicable insurance, and for any applicable
              deductibles. You agree to report any accident or damage to us immediately.
            </p>
          </Section>

          <Section title="6. Late Payments & Returns">
            <p>
              Weekly payments are due on schedule. Late or missed payments may result in suspension of the rental
              and recovery of the vehicle. Vehicles must be returned in the same condition as received, normal wear
              and tear excepted.
            </p>
          </Section>

          <Section title="7. Cancellations">
            <p>
              You may cancel before pickup; deposit refunds for cancellations are handled on a case-by-case basis.
              We reserve the right to cancel a reservation if eligibility cannot be verified.
            </p>
          </Section>

          <Section title="8. Communications Consent">
            <p>
              By providing your contact information, you consent to receive service-related and, where you opt in,
              promotional communications by phone, text, and email. You may opt out of marketing messages at any
              time (reply STOP to texts or use the unsubscribe link in emails). See our Privacy Policy for details.
            </p>
          </Section>

          <Section title="9. Limitation of Liability">
            <p>
              To the fullest extent permitted by law, Fair Rideshare LLC is not liable for indirect, incidental, or
              consequential damages arising from your use of our website or vehicles. Our total liability is limited
              to the amounts you paid for the applicable rental.
            </p>
          </Section>

          <Section title="10. Changes to These Terms">
            <p>
              We may update these Terms from time to time. Continued use of our website or services after changes
              are posted constitutes acceptance of the updated Terms.
            </p>
          </Section>

          <Section title="11. Contact Us">
            <p>
              Fair Rideshare LLC<br />
              Philadelphia, PA<br />
              Phone: 215-770-0679<br />
              Email: info@phillyrideshare.com
            </p>
          </Section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
